import EmblaCarousel from 'embla-carousel';

export class CarouselSlider extends HTMLElement {
  constructor() {
    super();
    this.axis = this.getAttribute('axis') || 'x';
    this.progress = this.getAttribute('progress') == 'true';
    this.isThumbnailCarousel = this.getAttribute('data-thumb-carousel') == 'true';
    this.isMainCarousel = this.getAttribute('data-main-carousel') == 'true';
    this.mainCarousel = document.querySelector('[data-main-carousel="true"]');
    this.isVideoCarousel = this.getAttribute('data-video-carousel') == 'true';
    this.wrapperNode = this.querySelector('.embla');
    this.viewportNode = this.querySelector('.embla__viewport');
    this.prevButtonNode = this.querySelector('.embla__prev');
    this.nextButtonNode = this.querySelector('.embla__next');
    this.progressNode = this.querySelector('.embla__progress__bar');
    this.startIndex = Number(this.getAttribute('start-index')) || 0;
    this.emblaApi = EmblaCarousel(this.viewportNode, { loop: false, axis: this.axis, startIndex: this.startIndex });
    this.thumbnailButtons = this.querySelectorAll('.embla__slide__number');
    this.dotsWrapper = this.querySelector('.embla__dots');
    this.dotNodes = [];
  }

  connectedCallback() {
    if (this.prevButtonNode) this.prevButtonNode.addEventListener('click', () => this.emblaApi.scrollPrev(), false);
    if (this.nextButtonNode) this.nextButtonNode.addEventListener('click', () => this.emblaApi.scrollNext(), false);

    if (this.isThumbnailCarousel && this.mainCarousel) {
      for (const thumbnailButton of this.thumbnailButtons) {
        thumbnailButton.addEventListener('click', () => {
          this.mainCarousel.getEmblaApi().scrollTo(Number(thumbnailButton.getAttribute('data-index')), false, 'forward');
        });
      }
    }

    if (this.isVideoCarousel) {
      this.setupVideo();
    }

    this.toggleButtonsDisabled();
    this.emblaApi.on('select', () => { this.toggleButtonsDisabled(); });
    this.emblaApi.on('reinit', () => { this.toggleButtonsDisabled(); });
    if (Boolean(this.progress) && this.progressNode) {
      this.emblaApi.on('reinit', () => { this.updateProgress(); })
      this.emblaApi.on('scroll', () => { this.updateProgress(); })
      this.emblaApi.on('slidefocus', () => { this.updateProgress(); })
    }

    if (this.dotsWrapper) {
      this.createAndSetupDotButtons();
      this.emblaApi.on('reInit', () => this.createAndSetupDotButtons());
      this.emblaApi.on('select', () => this.toggleDotButtonsActive())
    }
    
  }

  updateProgress() {
    const progress = Math.max(0, Math.min(1, this.emblaApi.scrollProgress()));
    this.progressNode.style.transform = `translate3d(${progress * 100}%,0px,0px)`;
  }

  toggleButtonsDisabled = () => {
    const setButtonState = (button, enabled) => {
      if (!button) return;
      button.toggleAttribute('disabled', !enabled);
    }
    setButtonState(this.prevButtonNode, this.emblaApi.canScrollPrev());
    setButtonState(this.nextButtonNode, this.emblaApi.canScrollNext());
  }

  getEmblaApi() {
    return this.emblaApi;
  }

  setupVideo() {
    const videos = this.querySelectorAll('video');
    for (const video of videos) {
      video.addEventListener('click', () => { this.showControls({ video, videos }); });
      video.addEventListener('play', () => { this.handleVideo({ video, videos }); });
    }
  }

  showControls(options) {
    const {video, videos} = options;
    if (!video.controls) {
      video.controls = true;
      this.handleVideo({ video, videos });
    }
  }

  handleVideo(options) {
    const {video, videos} = options;
    for (const extvideo of videos) {
      if (video != extvideo) {
        extvideo.pause();
      }
    }
    
    video.muted = false;
    video.play();
  }

  createDotButtonHtml() {
    const dotTemplate = this.querySelector('#embla-dot-template');
    const snapList = this.emblaApi.scrollSnapList();
    this.dotsWrapper.innerHTML = snapList.reduce((acc) => acc + dotTemplate.innerHTML, '');
    return Array.from(this.dotsWrapper.querySelectorAll('.embla__dot'));
  }

  addDotButtonClickHandlers() {
    this.dotNodes.forEach((dotNode, index) => {
      dotNode.addEventListener('click', () => this.emblaApi.scrollTo(index), false);
    })
  }

  createAndSetupDotButtons() {
    this.dotNodes = this.createDotButtonHtml();
    this.addDotButtonClickHandlers();
    this.toggleDotButtonsActive();
  }

  toggleDotButtonsActive() {
    if (!this.dotNodes.length) return;
    const previous = this.emblaApi.previousScrollSnap();
    const selected = this.emblaApi.selectedScrollSnap();
    this.dotNodes[previous].classList.remove('embla__dot--selected');
    this.dotNodes[selected].classList.add('embla__dot--selected');
  }

}